/**
 * Punto-en-polígono mediante ray casting. Equivalente al helper Python
 * `point_in_polygon` que vive en `/app/backend/core.py` — los dos deben
 * dar el mismo resultado para que la advertencia visual del cliente
 * coincida con la validación del servidor al crear el pedido.
 *
 * @param {number} lat
 * @param {number} lng
 * @param {Array<[number, number]>} polygon  Array de pares [lat, lng].
 * @returns {boolean}
 */
export function pointInPolygon(lat, lng, polygon) {
  if (!polygon || polygon.length < 3) return false;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const [yi, xi] = polygon[i];
    const [yj, xj] = polygon[j];
    const intersect =
      yi > lat !== yj > lat &&
      lng < ((xj - xi) * (lat - yi)) / (yj - yi + 1e-12) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}

/**
 * @param {number} lat
 * @param {number} lng
 * @param {Array<Array<[number, number]>>} polygons
 * @returns {boolean} true si el punto cae dentro de algún polígono.
 */
export function pointInAnyPolygon(lat, lng, polygons) {
  if (!polygons || polygons.length === 0) return false;
  return polygons.some((poly) => pointInPolygon(lat, lng, poly));
}
